import { useTranslation } from "react-i18next";
import { Button, ContentHeader, MainContentArea, Text, Tooltip } from "melco-ui";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { useEffect, useState } from "react";
import { useAddOnSearch } from "../../hooks/settings/useAddsOnSearch";
import { EodSettings } from "./EodSettings";
import { useAddOnActivate } from "../../hooks/settings/useAddsOnActivate";
import styled from "styled-components";
import { UnlockIcon } from "melco-ui";

export const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5%;
`;

export const EodSettingsWrapper: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("settings");

  const { hasSuccessData, refetch, isLoading } = useAddOnSearch()

  const addOnActivate = useAddOnActivate()

  const handleActivate = async () => {
    const response = await addOnActivate();     // call  activation API
    console.log("response is ", JSON.stringify(response))
    await refetch();  // refresh  data
  };

  if (isLoading) return null;

  if (!hasSuccessData) {
    return (
      <MainContentArea
        header={
          <ContentHeader
            title={t("eodsettings.title")}
            breadcrumb={breadcrumb}
          />
        }
      >
        <CenterWrapper>
          <Tooltip

            title={t("eodsettings.activate.tooltip")}>
            <Button icon={<UnlockIcon />} type="primary" onClick={() => { handleActivate() }}>{t("eodsettings.activate.button")}</Button>
          </Tooltip>
        </CenterWrapper>
      </MainContentArea>
    );
  }

  return <EodSettings />;


};
